import { render, staticRenderFns } from "./StcvD_ItemsRaw.vue?vue&type=template&id=645715e0"
import script from "./StcvD_ItemsRaw.vue?vue&type=script&lang=js"
export * from "./StcvD_ItemsRaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports